import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IAttributesState } from './types';
import { safeLocalStorage } from '../../../../../../../helpers/utils/safeStorage';

export const defaultAttributes = {
  attribution: [ '1' ],
  type_applications: [ '2' ],  // Нулевые заказы GC
} as {
  [key: string]: [string] | string;
};

const stateFromLocalStore =
  location.pathname === '/dashboards'
    ? undefined
    : safeLocalStorage.getItem('attr_state');
const defaultState: IAttributesState = {
  attributes:
    stateFromLocalStore && stateFromLocalStore !== 'undefined'
      ? JSON.parse(stateFromLocalStore)
      : defaultAttributes,
  attributesDashboard: defaultAttributes,
  attributesDashboardBlocks: {},
};
const getInitialState = () => {
  const url = new URL(window.location.href);
  const currentParams = url.searchParams.get('params');
  const paramsObject = currentParams ? JSON.parse(currentParams) : {};
  const attr = paramsObject?.attr;
  if (attr) {
    return { ...defaultState, ...attr };
  }
  return defaultState;
};
const initialState = getInitialState();

export const attrSlice = createSlice({
  name: 'attr',
  initialState: initialState,
  reducers: {
    setDashboardAttributes: (
      state,
      action: PayloadAction<{ [key: string]: [string] | string }>
    ) => {
      if (action.payload) {
        state.attributesDashboard = action.payload;
      }
    },
    setAttributes: (
      state,
      action: PayloadAction<{ [key: string]: [string] | string }>
    ) => {
      if (action.payload) {
        state.attributes = action.payload;
      }
    },
    setAttributesDashboardBlocks: (
      state,
      action: PayloadAction<{
        blockId: string;
        [key: string]: [string] | string;
      }>
    ) => {
      if (action.payload) {
        const { blockId, ...restPayload } = action.payload;
        state.attributesDashboardBlocks![blockId]! = { ...restPayload };
      }
    },
    /**
     * Очищает атрибуты для конкретного блока дашборда.
     * Вызывается при удалении блока для предотвращения утечки памяти.
     */
    clearBlockAttributes: (state, action: PayloadAction<string>) => {
      const blockId = action.payload;
      if (state.attributesDashboardBlocks && state.attributesDashboardBlocks[blockId]) {
        delete state.attributesDashboardBlocks[blockId];
      }
    },
  },
});

export const attrSliceReducer = attrSlice.reducer;
export const attrSliceActions = attrSlice.actions;
